 
<template>
  <div :class="settings.class">
    <vx-card :title=" totalOverAllPercentage == '' ? settings.label: settings.label +' : ' + totalOverAllPercentage + ' %'">
      <div class="mt-5">
        <chartjs-component-bar-chart
          :height="250"
          :data="data"
          :options="options"
        ></chartjs-component-bar-chart>
      </div>

      <template slot="codeContainer"> </template>
    </vx-card>
  </div>
</template>

<script>
import ChartjsComponentBarChart from "./components/ChartjsComponentBarChart.vue";
export default {
  data() {
    return {
      data: {
        labels: this.settings.value.label,
        datasets: [
          {
            label: " ",
            // backgroundColor: ["#3e95cd", "#8e5ea2", "#3cba9f", "#e8c3b9", "#c45850"],
            backgroundColor: [
              "#F5DEB3",
              "#28C76F",
              "#EA5455",
              "#FF9F43",
              "#AAFF00",
              "#7367F0",
            ],
            data: this.settings.value.val,
          },
        ],
      },
      options: {
        animation: {
          duration: 0, // general animation time
        },
        legend: { display: false },
        title: {
          display: true,
          text: this.settings.subLabel,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: this.settings.maxValue,
                stepSize: 10,
                reverse: false,
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },
  components: {
    ChartjsComponentBarChart,
  },
  props: {
    settings: Object,
    totalOverAllPercentage: {
      type: String,
      default: "",
    },
    default: {},
  },
  created() {
    console.log("bar seetings::", this.settings);
  },
};
</script> 